import { AnimatePresence, motion } from 'framer-motion';
import { PropsWithChildren } from 'react';

import CloseDrawerIcon from '@/components/icons/CloseDrawerIcon';

interface PopupProps extends PropsWithChildren {
  isOpen: boolean;
  onClose: () => void;
  title: string;
}

function Popup({ isOpen, onClose, title, children }: PopupProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <>
          <motion.div
            key="overlay"
            className="fixed inset-0 z-40 bg-black/40 backdrop-blur-sm"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onClose}
          />

          <motion.div
            key="modal"
            role="dialog"
            aria-modal="true"
            className="fixed top-1/2 left-1/2 z-50 w-[90vw] max-w-sm -translate-x-1/2 -translate-y-1/2 rounded-2xl bg-white p-3 shadow-2xl sm:p-4 md:p-6"
            initial={{ scale: 0.85, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.85, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 260, damping: 20 }}
          >
            <div className="mb-4 flex items-start justify-between gap-4">
              {title && <h2 className="text-lg font-semibold text-neutral-800">{title}</h2>}
              <button
                onClick={onClose}
                className="rounded-full p-1 transition hover:bg-neutral-100 focus:ring-2 focus:ring-blue-500 focus:outline-none"
              >
                <CloseDrawerIcon />
              </button>
            </div>

            {/* content */}
            <div className="text-sm text-neutral-700">{children}</div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
export default Popup;
